import validate from "/builds/common/airbaltic-com/company/node_modules/nuxt/dist/pages/runtime/validate.js";
import add_45trailing_45slash_45index_45global from "/builds/common/airbaltic-com/company/middleware/addTrailingSlashIndex.global.ts";
import manifest_45route_45rule from "/builds/common/airbaltic-com/company/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  add_45trailing_45slash_45index_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}